/* Created by Rowan de Zeeuw on 07/06/2018 */

import AbstractWidgetBaseController from '../base/controller';

const CONTENT_REF = 'contentRef';
const CONTENT_SERVICES_PROTOCOL = 'cs';
const STRUCTURED_CONTENT_CLASS = 'bd-structured-content-ng';
const $ = window.jQuery;

class AbstractStructuredContentController extends AbstractWidgetBaseController {
    constructor(widget, contentType) {
        super(widget);
        if (this.cxpWidget.isManageable()) {
            this.startDesignMode(contentType);
            if (this.cxpWidget.canEditContent()) {
                this.cxpWidget.prepareCxpPreferences();
            }
        }
    }

    /* TODO: Modified Backbase code, should be prettified more. */
    startDesignMode(desiredContentType) {
        if (!desiredContentType) {
            console.error('Content Type not defined');
        }

        const contentRef = this.widget.getPreference(CONTENT_REF);
        let dragItem;
        const $widget = $(this.widget.htmlNode);

        if (!contentRef) {
            $widget.addClass('bd-empty-structured-content');
        } else {
            $widget.addClass('bd-filled-structured-content');
        }

        $widget.append('<div class="' + STRUCTURED_CONTENT_CLASS + '"></div>');

        $('.' + STRUCTURED_CONTENT_CLASS, $widget).attr(
            'data-type',
            this.widget.getPreference('contentType') || 'Content'
        );

        this.widget.addEventListener('bdDrop.enter', e => {
            dragItem = undefined;

            const item = e.detail.info.helper.bdDragData.fileDataArray[0]; // e.detail.info.helper is a HTMLElement!@$#%

            if (
                item.metaData &&
                item.metaData['cmis:objectTypeId'] &&
                item.metaData['cmis:objectTypeId'].property === 'bb:structuredcontent'
            ) {
                $widget.addClass('bd-over-structured-content');
                const droppedContentType = item.metaData['bb:typeDefinitionName'].property;
                if (desiredContentType && droppedContentType !== desiredContentType) {
                    $widget.addClass('bd-over-structured-content-not-allowed');
                    $widget[0].setAttribute(
                        'data-droperror',
                        `Content type [${droppedContentType}] not allowed, expected type [${desiredContentType}]`
                    );
                } else {
                    dragItem = item;
                }
            }
        });
        this.widget.addEventListener('bdDrop.leave', e => {
            $widget.removeClass('bd-over-structured-content');
            $widget.removeClass('bd-over-structured-content-not-allowed');
            $widget[0].removeAttribute('data-droperror');
        });
        this.widget.addEventListener('bdDrop.drop', e => {
            if (dragItem) {
                if (!this.widget.model.preferences.getByName(CONTENT_REF)) {
                    const contentRefPref = window.b$.portal.portalModel.createPreference(
                        CONTENT_REF,
                        CONTENT_REF,
                        undefined,
                        ''
                    );
                    this.widget.model.preferences.add(contentRefPref);
                }
                this.widget.setPreference(
                    CONTENT_REF,
                    [
                        CONTENT_SERVICES_PROTOCOL,
                        dragItem.repository === 'contentRepository'
                            ? dragItem.repository
                            : '@portalRepository',
                        dragItem.contentUId,
                    ].join(':')
                );
                this.widget.model.save(() => {
                    this.widget.refreshHTML();
                    $widget.removeClass('bd-empty-structured-content');
                });
                $widget.removeClass('bd-over-structured-content');
                $widget.removeClass('bd-over-structured-content-not-allowed');
                $widget[0].removeAttribute('data-droperror');
            }
            dragItem = undefined;
        });

        if (window.bd && window.bd.bindDropEvents) {
            window.bd.bindDropEvents(this.widget.htmlNode);
        }
    }
}

export default AbstractStructuredContentController;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/abstract/structured-content/controller.js